import { requireNativeModule } from "expo";

// This call loads the native module object from the JSI.
export default requireNativeModule("ExpoWebviewVersion");
